import React from 'react';
import PropTypes from 'prop-types';
import RadioToggle from 'core/controls/radioToggle/RadioToggle';

const DriveTypeToggle = (props) => {
  const { options, selections, onChange, analyticsKey } = props;

  return (
    <RadioToggle
      className="drive-type-toggle"
      analyticsKey={analyticsKey}
      options={options}
      selected={(x) =>
        x.driveType === selections.driveType &&
        x.rearWheelType === selections.rearWheelType
      }
      onChange={onChange}
      renderLabel={(x) => (
        <>
          <div>
            <div className="drive-type-toggle__title">{x.label}</div>
            {x.rearWheelType && (
              <div className="drive-type-toggle__subtitle">
                {x.rearWheelType}
              </div>
            )}
            {!x.rearWheelType && x.description && (
              <div className="drive-type-toggle__subtitle">{x.description}</div>
            )}
          </div>
        </>
      )}
    />
  );
};

DriveTypeToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      driveType: PropTypes.string.isRequired,
      rearWheelType: PropTypes.string,
    })
  ).isRequired,
  selections: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DriveTypeToggle;
